import React from "react";
import { ValidationState } from "../types";

/**
 * This is used to plumb the validation state from the public API to the
 * places where it's used.
 */
export const ValidationContext = React.createContext<ValidationState>("default");
